<template>
    <client-page>
        <sub-visual subTab sh="About us" index="01" total="04" tabActive="Company Profile" bg="/images/sub/visual/sv1.jpg"> </sub-visual>

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Company Profile</h2>
                </div>
            </v-container>
            <div class="cover-bg py-40 py-md-60 py-lg-90" style="background-image:url(/images/sub/aboutus/company-profile-bg.jpg);">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="4" lg="4" order-md="2" offset-lg="1">
                            <div class="mb-20">
                                <v-img max-width="464" :aspect-ratio="464 / 250" src="/images/sub/aboutus/company-profile-logo.jpg" class="mx-auto mt-lg-n180" />
                            </div>
                        </v-col>
                        <v-col cols="12" md="8" lg="7" order-md="1">
                            <div class="page-text white--text">
                                <p>KIE (Korea Instrument and Electric) Systems brings rich experience and unique solution together in the engineering and integration such as analytical instruments.</p>
                                <p>
                                    This enables the company to meet the ever-increasing requirements of range of applications in the process industries carrying potentially hazardous chemicals and gases.
                                </p>
                                <p>
                                    The KIE Systems has held ISO9001 since 2003 and has successfully implemented a Total Quality program providing continuous improvements that offer significant benefits to the customer. This has built product confidence and a reputation of quality and reliability.
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </section>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit top-line-tit">Industries include</h3>
                </div>

                <v-item-group mandatory>
                    <v-row>
                        <v-item v-for="(item, i) in items" :key="i" v-slot="{ active, toggle }">
                            <v-col cols="12" :md="active ? '6' : '2'" class="transition">
                                <v-card tile elevation="0" class="cursor-pointer" @mouseenter="toggle">
                                    <v-img cover :src="active ? item.srcOn : item.src" style="position:relative;" class="w-100 h-200px h-md-500px">
                                        <div class="w-100 h-100" :class="active ? 'd-flex' : ''">
                                            <v-overlay absolute opacity="0.4" color="#000" class="mt-auto pa-20 px-md-60 py-md-32 h-100" :class="active ? 'h-100px justify-start' : ''">
                                                <div :class="active ? 'font-size-20 font-size-md-26' : 'font-size-16 font-size-md-18 text-center'">
                                                    <div :class="{ 'd-inline-block': active }">{{ item.num }}</div>
                                                    <div class="font-weight-bold" :class="{ 'd-inline-block pl-6 pl-md-10': active }">{{ item.title }}</div>
                                                </div>
                                            </v-overlay>
                                        </div>
                                    </v-img>
                                </v-card>
                            </v-col>
                        </v-item>
                    </v-row>
                </v-item-group>
            </v-container>
        </section>

        <section class="section grey-f7">
            <v-container>
                <div class="tit-wrap">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h3 class="tit top-line-tit">Core competencies</h3>
                        </v-col>
                        <v-col cols="12" md="6">
                            <p class="page-text pt-lg-18">
                                The company’s core competencies lie in the design, engineering, development of diverse kinds of analyzer systems. Placing the company at the forefront of innovation with a high commitment to research and engineering the company offers solutions to wide range of instrumentation and analyzer system.
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>

        <section class="section section--last pt-0 mt-n80 mt-md-n120 mt-lg-n160">
            <v-container>
                <div class="core-competencies-slide">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">01</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div class="mb-16 mb-md-24">
                                                    <h3 class="tit tit--sm">How we work</h3>
                                                </div>
                                                <div class="page-text">
                                                    <p>
                                                        With these markets continuously changing, The KIE Systems fully appreciates the need for organizations to maintain a flexible business approach. A global presence with an understanding of individual local needs has enabled the company to retain its competitive edge.
                                                    </p>
                                                    <p>
                                                        As a further extension to its manufacturing capabilities, the company offers project management for specialized process analyzer systems, service centers and 24 hour on-line technical support.
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide.jpg" />
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">02</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div class="mb-16 mb-md-24">
                                                    <h3 class="tit tit--sm">Engineering Capacity</h3>
                                                </div>
                                                <div class="page-text">
                                                    <p>
                                                        We have 25+ senior engineers in the analyzer team, and all of us are fluent in English conversation. Manufacturing, technology, and service experts are in your business. Our company is interested in QA/QC, and we are deploying personnel in the right place.
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide2.jpg" />
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">03</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div>
                                                    <div class="mb-16 mb-md-24">
                                                        <h3 class="tit tit--sm">Production capacity</h3>
                                                    </div>
                                                    <div class="page-text">
                                                        <v-row class="row--small">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols=""> As yearly basis, we can the analyzer package system around <b>100 packages</b> </v-col>
                                                        </v-row>
                                                        <v-row class="row--small mt-6">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="">
                                                                The shelter size will be around 5mW *3mD * 2.7mH
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>
                                                <div class="mt-30 mt-md-46">
                                                    <div class="mb-16 mb-md-24">
                                                        <h3 class="tit tit--sm">Factory Facilities</h3>
                                                    </div>
                                                    <div class="page-text">
                                                        <v-row class="row--small">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="">
                                                                Fabrication size : 31mW * 32.5mD (10007.5 sq.m)
                                                            </v-col>
                                                        </v-row>
                                                        <v-row class="row--small mt-6">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="">
                                                                Inspection size : 15mW * 32.5mD (487.5 sq.m)
                                                            </v-col>
                                                        </v-row>
                                                        <v-row class="row--small mt-6">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="" style="letter-spacing:-.03em !important;">
                                                                Conference room / Warehouse / Office / All tool sets
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide3.jpg" />
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">04</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div class="mb-16 mb-md-24">
                                                    <h3 class="tit tit--sm">After service</h3>
                                                </div>
                                                <div class="page-text">
                                                    <p>
                                                        Even after the project is completed, KIE SYSTEM’s after service will continue. We support site commissioning, Site Acceptance Test (SAT), troubleshooting and so on.
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide4.jpg" />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                        <div class="swiper-control">
                            <v-btn icon outlined large color="grey-d" class="swiper-prev border-1 mr-6 mr-lg-10"><i class="icon icon-left-arrow-grey"></i></v-btn>
                            <v-btn icon outlined large color="grey-d" class="swiper-next border-1"><i class="icon icon-right-arrow-grey"></i></v-btn>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data() {
        return {
            items: [
                {
                    src: "/images/sub/aboutus/company-profile-img.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img-on.jpg",
                    num: "01",
                    title: "Oil & Gas",
                },
                {
                    src: "/images/sub/aboutus/company-profile-img2.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img2-on.jpg",
                    num: "02",
                    title: "Petrochemical",
                },
                {
                    src: "/images/sub/aboutus/company-profile-img3.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img3-on.jpg",
                    num: "03",
                    title: "Power Plant",
                },
                {
                    src: "/images/sub/aboutus/company-profile-img4.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img4-on.jpg",
                    num: "04",
                    title: "Renewable Energy",
                },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.swiper = new Swiper(".core-competencies-slide .swiper-container", {
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 0,
                    // autoplay: {
                    //     delay: 5000,
                    //     disableOnInteraction: false,
                    // },
                    speed: 500,
                    loop: true,
                    navigation: {
                        nextEl: ".swiper-next",
                        prevEl: ".swiper-prev",
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.core-competencies-slide {
    .swiper-control {
        top: 10px;
        left: auto;
        right: 10px;
        transform: none;
        display: inline-flex;
        align-items: center;
        width: auto;
        padding: 0;
    }
    .swiper-prev,
    .swiper-next {
        position: relative;
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;
        transform: none;
        margin: 0;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .core-competencies-slide {
        .swiper-control {
            top: auto;
            bottom: 0;
            left: 0;
            right: auto;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
